import React, { useRef, useEffect} from 'react';
import CustomInput from "./Input";
import { Paper, List, ListItem, ListItemText, ListItemButton } from "@mui/material";

type Customer = {
  id: string;
  name: string;
};

type SearchFieldsProps = {
  alfa: string;
  artikkel: string;
  varegruppe: string;
  kundenummerInput: string;
  setAlfa: (value: string) => void;
  setArtikkel: (value: string) => void;
  setVaregruppe: (value: string) => void;
  setKundenummerInput: (value: string) => void;
  suggestedCustomers: Customer[];
  handleCustomerSelect: (customer: Customer) => void;
  kundenummerRef: React.RefObject<HTMLInputElement | null>;
  onFetchTransactions: () => void;
  onFetchKundeTopp50: () => void;
};

const SearchFields: React.FC<SearchFieldsProps> = ({
  alfa,
  artikkel,
  varegruppe,
  kundenummerInput,
  setAlfa,
  setArtikkel,
  setVaregruppe,
  setKundenummerInput,
  suggestedCustomers,
  handleCustomerSelect,
  kundenummerRef,
  onFetchTransactions,
  onFetchKundeTopp50,
}) => {
  const alfaRef = useRef<HTMLInputElement>(null);
  const artikkelRef = useRef<HTMLInputElement>(null);
  const varegruppeRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (alfaRef.current) {
      alfaRef.current.focus();
    }
  }, []);
  
  const handleChange = (setter: (value: string) => void, nextRef: React.RefObject<HTMLInputElement | null> | null = null, maxLength: number | null = null) => (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setter(value);

    // If maxLength is specified and reached, focus the next input field
    if (maxLength && value.length === maxLength && nextRef?.current) {
      nextRef.current.focus();
    }
  };
  const handleKeyPress =
  (type: string) => (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      if (type === "alfaArtikkel") {
        if (alfa && artikkel) {
          onFetchTransactions();
        } else {
          console.error("Alfa or Artikkel is missing.");
        }
      } else if (type === "kundenummer") {
        if (kundenummerInput) {
          onFetchKundeTopp50();
        } else {
          console.error("Kundenummer is missing.");
        }
      }
    }
  };
  
  const handleKundenummerChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setKundenummerInput(value);
  };

  const handleCustomerSelectWrapper = (customer: Customer) => {
    // Set kundenummerInput only, without modifying varegruppe
    setKundenummerInput(customer.id);
    // If any additional logic needs to be added when selecting a customer, do it here.
    handleCustomerSelect(customer);
  };

  const inputWidth = kundenummerRef.current ? kundenummerRef.current.offsetWidth : 'auto';

  return (
    <div style={{ padding:5, display: "flex", marginBottom: "10px", position: "relative" }}>
      <CustomInput
        value={alfa}
        onChange={handleChange(setAlfa, artikkelRef, 3)}
        placeholder="Alfa"
        ref={alfaRef}
      />
      <CustomInput
        value={artikkel}
        onChange={handleChange(setArtikkel, varegruppeRef, 14)}
        placeholder="Artikkel"
        ref={artikkelRef}
        onKeyDown={handleKeyPress("alfaArtikkel")}
      />
      <CustomInput
        value={varegruppe}
        onChange={handleChange(setVaregruppe, kundenummerRef, 5)}
        placeholder="Varegruppe"
        ref={varegruppeRef}
      />
      <div style={{ position: "relative", width: '100%' }}>
        <CustomInput
          value={kundenummerInput}
          onChange={handleKundenummerChange}
          placeholder="Kundenummer"
          ref={kundenummerRef}
          onKeyDown={handleKeyPress("kundenummer")}
        />
        {suggestedCustomers && suggestedCustomers.length > 0 && suggestedCustomers[0].id && (
          <Paper
            style={{
              position: "absolute",
              top: "100%",
              left: 0,
              width: inputWidth,
              zIndex: 1,
              maxHeight: "200px",
              overflowY: "auto",
            }}
          >
            <List>
              {suggestedCustomers.map((customer) => (
                <ListItem
                  key={customer.id}
                  disablePadding
                >
                  <ListItemButton onClick={() => handleCustomerSelectWrapper(customer)}>
                    <ListItemText primary={`${customer.id} - ${customer.name}`} />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          </Paper>
        )}
      </div>
    </div>
  );
};

export default SearchFields;
